import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent } from 'vue';
import { verification } from '@/utils/index';
import api from '@/api/index.js';
import roleHooks from '@/hooks/roleHooks';
import roleV2Hooks from '@/hooks/roleV2Hooks';
import { useStore } from 'vuex';
let Store = useStore();
export default defineComponent({
  name: 'yzmLogin',
  data() {
    return {
      checked: false,
      phone: '',
      code: '',
      isError: false,
      timeOver: true,
      time: 60,
      isErrorCode: false,
      errorMessage: '',
      errorCode: false,
      error: false,
      warning: false,
      showBottomLogo: true,
      clientHeight: document.documentElement.clientHeight
    };
  },
  mounted() {
    window.onresize = () => {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showBottomLogo = false;
      } else {
        this.showBottomLogo = true;
      }
    };
  },
  watch: {
    phone(val) {
      const phone = val.replace(/\s+/g, '').trim();
      let Reg = /^(\+?0?86-?)?1[3456789]\d{9}$/;
      const stat = verification(Reg)(phone);
      this.formate(val);
      if (stat) {
        this.isError = false;
      }
    }
  },
  setup(props, context) {
    const {
      initAllRoleList
    } = roleHooks();
    const {
      initAllRoleList: initAllRoleListV2
    } = roleV2Hooks();
    return {
      initAllRoleList,
      initAllRoleListV2
    };
  },
  methods: {
    phoneBlur() {
      const phone = this.phone.replace(/\s+/g, '').trim();
      let Reg = /^(\+?0?86-?)?1[3456789]\d{9}$/;
      const stat = verification(Reg)(phone);
      if (!stat) {
        this.isError = true;
      }
    },
    formate(val) {
      if (val.length < 13) {
        if (val.length > 3 && val.length < 7) {
          val = val.replace(/\s/g, ' ').replace(/[^\d]/g, ' ').replace(/(\d{3})(?=\d)/g, '$1 ');
        } else if (val.length >= 7) {
          val = val.replace(/\s/g, ' ').replace(/[^\d]/g, ' ').replace(/(\d{4})(?=\d)/g, '$1 ');
        }
        this.phone = val;
      }
    },
    async getCode() {
      if (!this.phone || this.isError) return;
      const res = await api.login.getCode({
        phone: this.phone.replace(/\s+/g, ''),
        usage: 'login'
      });
      console.log(res);
      if (res.code !== 200) {
        this.error = true;
        this.warning = false;
        this.errorMessage = res.msg;
        return false;
      }
      this.time = 60;
      this.timeOver = false;
      this.countDown();
    },
    countDown() {
      setTimeout(() => {
        this.time--;
        if (this.time > 0) {
          this.timeOver = false;
          this.countDown();
        } else {
          this.timeOver = true;
        }
      }, 1000);
    },
    async login() {
      if (!this.phone || this.isError || !this.code.trim()) return;
      if (!this.phone) {
        ElMessage.error({
          message: '请输入手机号',
          duration: 3000
        });
        return;
      }
      if (!this.code.trim()) {
        ElMessage.error({
          message: '请输入验证码',
          duration: 3000
        });
        return;
      }
      if (!this.checked) {
        this.error = false;
        this.warning = true;
        this.errorMessage = '请勾选已阅读并同意《服务协议》和《隐私协议》';
        return;
      }
      let res = await api.login.login({
        phone: this.phone.replace(/\s+/g, ''),
        code: this.code.trim()
      });
      if (res.code !== 200) {
        this.isErrorCode = true;
        this.error = true;
        this.warning = false;
        this.errorMessage = res.msg;
      } else {
        this.$store.commit('userInfo/setToken', {
          token: res.data
        });
        let resUserInfo = await api.login.getUserInfo();
        if (resUserInfo.code == 200) {
          this.$store.commit('userInfo/setUserInfo', resUserInfo.data);
        }
        let queryRoleres;
        if (this.$route.path != '/v2') {
          this.initAllRoleList();
          // queryRoleres = await queryRole({})
        } else {
          this.initAllRoleListV2();
          // queryRoleres = await queryRoleV2({})
        }
        // if (queryRoleres.code == 200) {
        // this.$store.commit('role/setonwerAllRoleList', queryRoleres.data)
        // }
        this.error = false;
        this.warning = false;
        ElMessage.success({
          message: '登录成功',
          duration: 3000
        });
      }
    }
  }
});